module.exports = __webpack_public_path__ + "img/language.cd096b2a.svg";